import React from 'react';

const ML_Recognition = () => {
    return (
        <div>ML_Recognition Component</div>
    );
}

export default ML_Recognition;
